import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: 32,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners
  },
  coApplicantContainer: {
    paddingBottom: 28
  },
  driverContainer: {
    paddingBottom: 28
  },
  coApplicant: {
    marginLeft: -3,
    marginRight: 20,
    display: 'flex',
    alignItems: 'center',
    height: 'inherit'
  },
  coApplicantHelperText: {
    position: 'absolute',
    bottom: -12
  },
  cardFooter: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: '16px 32px',
    borderTop: `1px solid ${theme.colorPalette.beige_10}`,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners
  },
  recalculateButton: {
    marginLeft: 12,
    display: 'none' // Hide until backend is done
  },
  swapButtonHelperText: {
    color: theme.colors.button__background_secondary,
    width: 190
  },
  swapButtonDisabled: {
    color: theme.colorPalette.orange_50,
    opacity: '50%'
  },
  excludeDriverCheckboxDisabled: {
    marginRight: 0
  },
  driverExcluded: {
    backgroundColor: theme.colorPalette.beige_10
  },
  driverIncluded: {
    backgroundColor: theme.colors.card_background_primary_editable
  }
}));

export default useStyles;
